import React from "react";
import { Grid } from "@mui/material";
import "./reportHeader.scss";
import DownloadIcon from "@mui/icons-material/Download";
import { Button } from "@mui/material";
import { convertToLocalTime } from "../../../../../utils/helper";

const ReportHeader = ({ headerData, handlePrint, logoCheck }) => {
  return (
    <>
      <div className="overReportHeader">
        <Grid container className="reportHeader">
          <Grid md={4} xs={12} className="reportHeaderLeft">
            <div className="reportTitle">
              Report ID: {headerData?.report_Id}
            </div>
          </Grid>
          <Grid md={8} xs={12} className="reportHeaderRight">
            <Grid md={2} sm={2} xs={8} className="reportHeaderLeft right">
              <div className="hbLogo">
                <img src={logoCheck} alt="" />
              </div>
            </Grid>
            <Grid md={6} xs={12}>
              <div className="reportDesc">
                Reported on:
                <span>{convertToLocalTime(headerData.conducted_On)}</span>
              </div>
            </Grid>
            <Grid md={4} xs={12}>
              <Button
                onClick={handlePrint}
                variant="contained"
                startIcon={<DownloadIcon className="downloadIcon" />}
                className="downloadpdf"
              >
                View PDF
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default ReportHeader;
